<template src="./graficaRhb.html">
    
</template>
<script>
export default {
    methods: {
        verGrafica2(){
            this.$router.push({name: 'graficaRhbAuxiliar'})
            // this.$router.push({name: 'tablaRhb'})
        }
    },
    props: ['id'],
}
</script>
<style src="./graficaRhb.scss" lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Gestion/gestionRehabilitacion/graficaRhb/graficaRhb.vue